import { render, staticRenderFns } from "./NotificationSaleDropDown.vue?vue&type=template&id=10cd3710&"
import script from "./NotificationSaleDropDown.vue?vue&type=script&lang=js&"
export * from "./NotificationSaleDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports